module.exports = __webpack_public_path__ + "static/media/topBottom.ae14e2b9.svg";